import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import "./change-password-dialog.css";

function detail(body: unknown) {
  if (!body || typeof body !== "object" || !("detail" in body)) return "";
  const value = (body as { detail?: unknown }).detail;
  if (typeof value === "string") return value;
  if (value && typeof value === "object" && "message" in value) return String((value as { message?: unknown }).message || "");
  return "";
}

export function ChangePasswordDialog({ onClose }: { onClose: () => void }) {
  const queryClient = useQueryClient();
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit() {
    setError("");
    if (!currentPassword) return setError("Podaj obecne hasło.");
    if (password.length < 8) return setError("Nowe hasło musi mieć minimum 8 znaków.");
    if (password !== confirmPassword) return setError("Hasła nie są takie same.");
    setBusy(true);
    try {
      const response = await fetch("/api/auth/change-password", { method: "POST", credentials: "include", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ currentPassword, password, confirmPassword }) });
      const body = await response.json().catch(() => null);
      if (!response.ok) throw new Error(detail(body) || `HTTP ${response.status}`);
      await queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
      onClose();
    } catch (exc) { setError(exc instanceof Error ? exc.message : "Nie udało się zmienić hasła."); }
    finally { setBusy(false); }
  }

  return <div className="password-dialog-layer" role="dialog" aria-modal="true" aria-label="Zmień hasło">
    <button className="password-dialog-backdrop" type="button" aria-label="Zamknij" onClick={onClose} />
    <section className="password-dialog-card">
      <header><div><span className="eyebrow">TWOJE KONTO</span><h3>Zmień hasło</h3></div><button type="button" onClick={onClose}>×</button></header>
      <label><span>Obecne hasło</span><input autoFocus type="password" autoComplete="current-password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} /></label>
      <label><span>Nowe hasło</span><input type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} /></label>
      <label><span>Powtórz nowe hasło</span><input type="password" autoComplete="new-password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} /></label>
      {error ? <div className="password-dialog-error">{error}</div> : null}
      <footer><button type="button" className="secondary-button" onClick={onClose}>Anuluj</button><button type="button" className="primary-button" disabled={busy} onClick={() => void submit()}>{busy ? "Zmieniam…" : "Zmień hasło"}</button></footer>
    </section>
  </div>;
}
